import config from "./config.js";

function showVersionUpgradeMessage() {
  document.body.innerHTML = `
        <div style='padding: 15px'>
            <h4 style='color: indianred'>
                Please Update Your Application
            </h4>
            <p>
                Your installed version of the app is no longer supported. Please update
                to the latest version.
            </p>
        <div>`;
}

function showFetchErrorMessage() {
  document.body.innerHTML = `<div style='padding: 15px'>
            <h4 style='color: indianred'>Could not connect to the network.</h4>
            <p>Please close and restart the application to try again.</p>
        </div>`;
}

function showAppErrorMessage() {
  document.body.innerHTML = `<div style='padding: 15px'>
            <h4 style='color: indianred'>The application encountered an error.</h4>
            <p>Please close and restart the application to try again or contact
                us for assistance.</p>
        </div>`;
}

async function checkIfVersionSupported() {
  // Only applicable for Cordova. For web, client version will always be
  // the latest one
  if (!window.cordova) {
    return;
  }
  let url = new URL(`${config.serverUrl}/minimumSupportedClientVersion`);
  url.searchParams.append("platform", window.device.platform);
  let response;
  try {
    response = await fetch(url);
  } catch (e) {
    // Handle fetch() network error exception (not 4xx or 5xx response)
    if (e instanceof TypeError && e.message === "Failed to fetch") {
      showFetchErrorMessage();
    }
    throw e;
  }
  if (!response.ok) {
    showAppErrorMessage();
    throw new Error("could not get minimum supported app version");
  }

  let minimumSupportedClientVersion = parseInt(await response.text());
  if (config.version < minimumSupportedClientVersion) {
    showVersionUpgradeMessage();
    throw new Error("unsupported client version");
  }
}

export default checkIfVersionSupported;
